import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { PayrollPhase } from 'modules/payroll_bundle/lib/enums'

import { comparePaths } from './comparePaths'
import { PathSegment } from './types'

interface Options {
  path: string
  policyId: PathSegment
  policyPeriodId: PathSegment
  navigation: ReturnType<typeof useNavigation>['navigation']
}

export function useGetSelectedTab({ path, policyId, policyPeriodId, navigation }: Options) {
  const status = useUnsafeMemo(() => {
    const {
      payrollBundle: {
        policy: {
          period: { cycles },
        },
      },
    } = navigation

    if (comparePaths(path, cycles.supplements.fullPath({ policyId, periodId: policyPeriodId }))) {
      return PayrollPhase.SUPPLEMENTS_DEFINITION
    }

    if (comparePaths(path, cycles.results.fullPath({ policyId, periodId: policyPeriodId }))) {
      return PayrollPhase.PAYROLL_CALCULATION
    }

    if (comparePaths(path, cycles.payments.fullPath({ policyId, periodId: policyPeriodId }))) {
      return PayrollPhase.PAYMENT
    }

    return null
  }, [path, policyId, policyPeriodId, navigation])

  return status
}
